import React, {FC, useState} from "react"
import tracking from "@irati-tracking/search"
import SearchBar from "@irati-web/search/src/components/Popups/SearchBar"
import SearchBarComponent from "@irati-web/platform/src/components/Header/shared/SearchBarComponent"
import Flex from "@irati/ui/src/Flex"

interface DealSearchProps {}

const DealSearch: FC<DealSearchProps> = () => {
  const [showSearchBar, setShowSearchBar] = useState<boolean>(false)

  const handleSearch = () => {
    if (!showSearchBar) {
      tracking.startSearch()
    }

    setShowSearchBar((current) => !current)
  }

  return (
    <>
      <Flex alignItems="center" onClick={handleSearch}>
        <SearchBarComponent />
      </Flex>
      <SearchBar id="searchBarId" show={showSearchBar} onClose={handleSearch} isMobile />
    </>
  )
}

export default DealSearch
